import { useState, useEffect } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "@/config/firebase";
import { toDate, toDateOptional } from "@/lib/dates";
export function useTicketStream(ticketId) {
    const [ticket, setTicket] = useState(null);
    const [agentStatus, setAgentStatus] = useState(null);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        if (!ticketId) {
            setLoading(false);
            return;
        }
        setLoading(true);
        const ticketUnsub = onSnapshot(doc(db, "tickets", ticketId), (snapshot) => {
            if (snapshot.exists()) {
                const data = snapshot.data();
                setTicket({
                    ...data,
                    id: snapshot.id,
                    createdAt: toDate(data.createdAt),
                    updatedAt: toDate(data.updatedAt),
                    investigationStartedAt: toDateOptional(data.investigationStartedAt),
                    investigationCompletedAt: toDateOptional(data.investigationCompletedAt),
                    fixStartedAt: toDateOptional(data.fixStartedAt),
                    stagingReadyAt: toDateOptional(data.stagingReadyAt),
                    approvedAt: toDateOptional(data.approvedAt),
                    mergedAt: toDateOptional(data.mergedAt),
                    closedAt: toDateOptional(data.closedAt),
                });
            }
            else {
                setTicket(null);
            }
            setLoading(false);
        }, (err) => {
            console.error("Ticket stream error:", err);
            setLoading(false);
        });
        const agentUnsub = onSnapshot(doc(db, "agentStatus", ticketId), (snapshot) => {
            if (snapshot.exists()) {
                const data = snapshot.data();
                setAgentStatus({
                    ...data,
                    startedAt: toDate(data.startedAt),
                    lastUpdateAt: toDate(data.lastUpdateAt),
                });
            }
            else {
                setAgentStatus(null);
            }
        }, (err) => {
            console.error("Agent status stream error:", err);
        });
        return () => {
            ticketUnsub();
            agentUnsub();
        };
    }, [ticketId]);
    return { ticket, agentStatus, loading };
}
